import { ReactNode, useState } from "react";
import styles from './aboutDestination.module.css';
import global from '../bid.module.css';

import { VariableImage, VariableLink } from "../";

type PropsDestinationDetail = {
  title: string,
  text: string,
  link: any,
  picture: number,
  images: [
    {
      title: string,
      format: {
        original: {
          uri: string
        }
      },
      id: number
    }
  ],
  themeFormat: object
}

const DestinationDetail = ({ title, text, link, picture, images, themeFormat }: PropsDestinationDetail) => {
  const imageContent = images.find(x => x.id === picture);
  return (
    <div className={styles.Detail}>
      <article>
        <h5>{title}</h5>
        <p>{text}</p>
        {link?.href?.length > 0 && (
          <VariableLink {...link} styledAs="button" themeFormat={themeFormat}>
            Read More
          </VariableLink>
        )}
      </article>
      {imageContent && (
        <figure>
          <VariableImage image={imageContent} origin='internal' lazy={true} priority={false} />
        </figure>
      )}
    </div>
  )
};

type Props = {
  title: ReactNode,
  data: [
    {
      title: string,
      text: string,
      link: string
    }
  ],
  images: [
    {
      title: string,
      format: {
        original: {
          uri: string
        }
      },
      id: number
    }
  ],
  themeFormat: {
    primaryText: string,
    secondaryText: string,
    primary: string,
    secondary: string
  }
}

const AboutDestination = ({ title, data, images, themeFormat }: Props) => {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <section className={global.Container} id="tabs">
      <h3 className={styles.title}>{title}</h3>
      <ul className={styles.Tabs}>
        {data.map(({ title }, index) => (
          <li className={styles.Tab} key={title}>
            <button style={{
              color: index == activeTab ? themeFormat.primaryText : themeFormat.secondaryText,
              backgroundColor: index == activeTab ? themeFormat.primary : themeFormat.secondary
            }}
              onClick={() => setActiveTab(index)}>{title}</button>
          </li>
        ))}
      </ul>
      <DestinationDetail picture={0} {...data[activeTab]} images={images} themeFormat={themeFormat} />
    </section>
  );
};

export default AboutDestination;
